import * as Business   from '../business';
import { connect }     from 'react-redux';
import { format }      from 'date-fns';
import { parseISO }    from 'date-fns';
import FetchFromServer from '../components/fetch_from_server';
import Navbar          from '../components/navbar';
import React           from 'react';


const DEFAULT_DAYS = 30;

export default connect(
  (state, { businessID }) => ({
    businessID,
    businessName: Business.getBusinessName(state, businessID),
    feedback:     Business.getFeedback(state, businessID),
    stats:        Business.getFeedbackStats(state, businessID, DEFAULT_DAYS),
    statuses:     [
      Business.getFeedbackStatsStatuses(state, businessID, DEFAULT_DAYS),
      Business.getFeedbackStatuses(state, businessID)
    ]
  }),
  (dispatch, { businessID }) => ({
    load: () => {
      dispatch(Business.loadBusiness(businessID));
      dispatch(Business.readFeedback(businessID));
      dispatch(Business.readFeedbackStats(businessID, DEFAULT_DAYS));
    }
  })
)(PrivateFeedbackPage);

const BusinessContext = React.createContext();

export function PrivateFeedbackPage({ businessID, businessName, feedback, stats, statuses, load }) {
  const isReady = !!feedback && !!businessName;

  return (
    <React.Fragment>
      <Navbar title="Private Feedback"/>
      <FetchFromServer statuses={statuses} load={load}>
        {isReady && (
          <FeedbackContent
            stats={stats}
            feedback={feedback}
            businessID={businessID}
            businessName={businessName}/>
        )}
      </FetchFromServer>
    </React.Fragment>
  );
}

function FeedbackContent({ stats, feedback, businessID, businessName }) {
  const hasFeedback = feedback.length > 0;

  if (hasFeedback) {
    return (
      <React.Fragment>
        {stats && <FeedbackAggregates {...stats.aggregates}/>}
        <BusinessContext.Provider value={{ id: businessID, name: businessName }}>
          <Feedback feedback={feedback}/>
        </BusinessContext.Provider>
      </React.Fragment>
    );
  } else
    return <NoFeedback/>;
}


function FeedbackAggregates({ customerCount, customersWithFeedbackCount, days = DEFAULT_DAYS }) {
  const customersWithFeedbackPercentage = customerCount > 0 ? customersWithFeedbackCount * 100 / customerCount : 0;

  return (
    <React.Fragment>
      <div className="aggregates block">
        <div className="headline">LAST {days} DAYS</div>
        <div className="aggregates__header row">
          <div className="aggregates__col col">
            <div className="aggregates__container">
              <div className="aggregates__stat">{customerCount}</div>
              Customers Added
            </div>
          </div>
          <div className="aggregates__col col">
            <div className="aggregates__container">
              <div className="aggregates__stat">{formatPercentage(customersWithFeedbackPercentage)}</div>
              Left Private Feedback
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function formatPercentage(value) {
  const percentage = parseInt(value, 10);
  return `${percentage}%`;
}


function Feedback({ feedback }) {
  return (
    <div className="feedback-container block">
      <div className="headline">
      PRIVATE FEEDBACK - ALL TIME
      </div>
      <div className="feedback-list list media-list">
        <ul className="feedback-list__container">
          {feedback.map(message => <FeedbackMessage key={message.id} {...message}/>)}
        </ul>
      </div>
    </div>
  );
}

function FeedbackMessage({ customer, receivedAt, body }) {
  return (
    <BusinessContext.Consumer>
      {({ id, name }) => {
        const href = customer?.conversation?.id ?
          `/${id}/inbox/${customer.conversation.id}` :
          `/${id}/contacts/${customer?.id}`;

        return (
          <li className="feedback-message item-content" key={customer.id}>
            <div className="item-inner">
              <div className="feedback-message__row item-title-row">
                <a href={href}>
                  <div className="item-title">{customer.name.full}</div>
                </a>
                <div className="feedback-message__after item-after">{format(parseISO(receivedAt), 'MM/dd/yyyy')}</div>
              </div>
              <FeedbackText body={body} customer={customer} businessName={name}/>
              <div className="feedback-message__reply">
                <a href={href}>Reply</a>
              </div>
            </div>
          </li>
        );
      }}
    </BusinessContext.Consumer>
  );
}

function FeedbackText({ body, customer, businessName }) {
  return (
    <div className="feedback-message__text">
      {body}
      {!body && (
        <i className="feedback-message__text--empty">
          {customer.name.full} hasn’t left feedback yet,
          but indicated they would not recommend {businessName} based
          on a recent experience.
        </i>
      )}
    </div>
  );
}


function NoFeedback() {
  return (
    <div className="block">
      <div className="empty-page">
        <div className="empty-page__note">
          You haven&apos;t received any private feedback from your customers yet.
        </div>
        <div className="empty-page__icons">
          <i className="empty-page__icon icons8 icons8-electrical"></i>
        </div>
      </div>
    </div>
  );
}
